import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container my-2" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "row row-cols-1 g-4 mb-4" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-10 offset-2" }
const _hoisted_8 = { class: "form-group d-flex align-items-center gap-2" }
const _hoisted_9 = { class: "w-100" }
const _hoisted_10 = { class: "w-100" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "d-flex h-100" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {"min-height":"max-content"}
}
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = { class: "fixed-bottom bg-white d-flex gap-2 align-items-center py-2 px-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "text-secondary" }
const _hoisted_20 = {
  class: "modal fade",
  id: "routeModal",
  "aria-hidden": "true",
  tabindex: "-1"
}
const _hoisted_21 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modal-header" }
const _hoisted_24 = { class: "modal-title" }
const _hoisted_25 = { class: "modal-body" }
const _hoisted_26 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventCard = _resolveComponent("EventCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Номер запроса ")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.id) = $event)),
                      type: "number",
                      class: "form-control form-control-sm w-100"
                    }, null, 512), [
                      [_vModelText, _ctx.filters.id]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_10, [
                    _cache[6] || (_cache[6] = _createTextVNode(" Статус ")),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.status) = $event)),
                      class: "form-control form-control-sm w-100"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: status.status
                        }, _toDisplayString(status.name), 9, _hoisted_11))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.filters.status]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchEvents())),
                      class: "btn btn-sm btn-primary mt-auto",
                      style: {"margin-top":"25px !important"}
                    }, _cache[7] || (_cache[7] = [
                      _createElementVNode("i", { class: "bi bi-search" }, null, -1)
                    ]))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.paginate.count)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.events, (event, i) => {
                  return (_openBlock(), _createBlock(_component_EventCard, {
                    key: i,
                    event: event,
                    statusFormat: _ctx.getStatusRequest,
                    "onEvent:openRouteModal": _ctx.onSelectEvent
                  }, null, 8, ["event", "statusFormat", "onEvent:openRouteModal"]))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[8] || (_cache[8] = [
                  _createElementVNode("span", { class: "fw-bold" }, "Список заявок пуст", -1)
                ])))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            disabled: (_ctx.paginate.pages[0] === _ctx.paginate.page) || !_ctx.paginate.count,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.next(!_ctx.paginate.page ? _ctx.paginate.page : _ctx.paginate.page - 1))),
            class: "btn btn-sm btn-primary"
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "bi bi-arrow-left-square" }, null, -1)
          ]), 8, _hoisted_17),
          _createElementVNode("button", {
            disabled: (_ctx.paginate.pages[_ctx.paginate.pages.length - 1] === _ctx.paginate.page) || !_ctx.paginate.count,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.next(_ctx.paginate.page + 1))),
            class: "btn btn-sm btn-primary"
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "bi bi-arrow-right-square" }, null, -1)
          ]), 8, _hoisted_18),
          _createElementVNode("span", _hoisted_19, " Текущая страница: " + _toDisplayString(_ctx.paginate.page + 1), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h5", _hoisted_24, _toDisplayString(_ctx.selectedEvent ? `#${_ctx.selectedEvent.id}` : 'Запрос не найден'), 1),
            _cache[11] || (_cache[11] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_ctx.selectedEvent)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedEvent.technics, (technic, i) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    key: i,
                    class: "list-unstyled"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(technic.treads, (tread, j) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tread.tasks, (task, k) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                            (task.geo_task_type === 10)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_26, _toDisplayString(task.geo_tasks_name), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ], 64))
                    }), 128))
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}